import { gql } from '@apollo/client';

export const UPDATE_COMMUNITY_SPACE_LAST_READ_MUTATION = gql`
  mutation updateCommunitySpaceLastRead($input: UpdateCommunitySpaceLastReadInput!) {
    updateCommunitySpaceLastRead(input: $input) {
      userErrors {
        code
        message
      }
      lastReadAt
    }
  }
`;
